// FAQ.tsx
import { useState } from "react";
import {
  FAQAnswer,
  FAQIcon,
  FAQItem,
  FAQQuestion,
  FAQWrapper,
} from "../style/faq_Style";
import { FaqItem } from "../models/faq";
import { useTranslation } from "react-i18next";
// const faqs = [
//   {
//     question: "Dịch tài liệu có giới hạn số trang không?",
//     answer:
//       "Hiện tại hệ thống hỗ trợ dịch tài liệu lên đến 50 trang cho mỗi lần tải lên.",
//   },
//   {
//     question: "Dữ liệu của tôi có được bảo mật không?",
//     answer:
//       "Tất cả tài liệu đều được mã hóa và tự động xóa sau khi hoàn tất quá trình dịch.",
//   },
//   {
//     question: "Hệ thống hỗ trợ những định dạng nào?",
//     answer:
//       "Chúng tôi hỗ trợ PDF, DOCX, PPTX và các định dạng văn bản phổ biến khác.",
//   },
// ];

interface Props {
  faqs: FaqItem[];
}

const FAQ: React.FC<Props> = ({ faqs }) => {
  const [openIndex, setOpenIndex] = useState<number | null>(null);
  const { t } = useTranslation();
  const toggle = (index: number) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  return (
    <>
      <h2 style={{ textAlign: "center" }}>{t("faq.title")}</h2>
      <p style={{ textAlign: "center", marginBottom: "30px" }}>
        {t("faq.description")}
      </p>
      <FAQWrapper>
        {faqs.map((item, index) => {
          const open = openIndex === index;

          return (
            <FAQItem key={index}>
              <FAQQuestion onClick={() => toggle(index)}>
                {item.question}
                <FAQIcon open={open} />
              </FAQQuestion>

              {open && (
                <FAQAnswer
                  dangerouslySetInnerHTML={{ __html: item.answer ?? "" }}
                />
              )}
            </FAQItem>
          );
        })}
      </FAQWrapper>
    </>
  );
};
export default FAQ;
